import React, { Component } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import axios from "axios";

export default class EditExercise extends Component {
  constructor() {
    super();
    this.state = {
      username: "",
      description: "",
      duration: 0,
      date: new Date(),
      users: [],
    };
    this.onChangUsername = this.onChangUsername.bind(this);
    this.onChangeDesc = this.onChangeDesc.bind(this);
    this.onChangeDuration = this.onChangeDuration.bind(this);
    this.onChangDate = this.onChangDate.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
  }

  async componentDidMount() {
    await axios.get('https://backend-of-tracker.herokuapp.com/exercises/'+this.props.match.params.id)
    .then(response=>{
        this.setState({
            username: response.data.username,
            description: response.data.description,
            duration:response.data.duration,
            data: new Date(response.data.date)
        })
    })
    .catch(err=>console.log(err))

    await axios.get("https://backend-of-tracker.herokuapp.com/users").then((response) => {
      this.setState({
        users: response.data.map((user) => user.username),
      });
    });
  }

  onChangUsername(e) {
    this.setState({
      username: e.target.value,
    });
  }
  onChangeDesc(e) {
    this.setState({
      description: e.target.value,
    });
  }
  onChangeDuration(e) {
    this.setState({
      duration: e.target.value,
    });
  }
  onChangDate(date) {
    this.setState({
      date: date,
    });
  }
  async onSubmit(e) {
    e.preventDefault();
    const exercise = {
      username: this.state.username,
      description: this.state.description,
      duration: this.state.duration,
      date: this.state.date,
    };
    await axios
      .post("https://backend-of-tracker.herokuapp.com/exercises/update/"+this.props.match.params.id, exercise)
      .then((res) => alert(res.data))
    window.location = "/";
  }
  render() {
    return (
      <div>
        <h3>Edit Exercise Log</h3>
        <form onSubmit={this.onSubmit}>
          <div className="form-group">
            <label htmlFor="">Username:</label>
            <select
              value={this.state.username}
              onChange={this.onChangUsername}
              className="form-control"
              ref="userInput"
            >
              {this.state.users.map((user) => {
                return <option key={user}>{user}</option>;
              })}
            </select>
          </div>
          <div className="form-group">
            <label htmlFor="">Description:</label>
            <input
              onChange={this.onChangeDesc}
              type="text"
              value={this.state.description}
              className="form-control"
            />
          </div>
          <div className="form-group">
            <label htmlFor="">Duration (in minutes):</label>
            <input
              onChange={this.onChangeDuration}
              type="number"
              className="form-control"
              value={this.state.duration}
            />
          </div>
          <div className="form-group">
            <label htmlFor="">Date:</label>
            <div>
              <DatePicker
                onChange={this.onChangDate}
                selected={this.state.date}
                className="form-control"
              />
            </div>
          </div>
          <div className="form-group">
            <input
              onClick={this.onSubmit}
              type="button"
              value="Edit Exercise"
              className="btn btn-primary"
            />
          </div>
        </form>
      </div>
    );
  }
}
